<style scoped>
.form-label.required::after {
    content: '*';
    @apply text-red inline-block pl-1;
}
</style>

<template>
    <label class="form-row">
        <div :class="['form-label', labelWidthClass, requiredClass]">
            {{ label }}
        </div>
        <div class="flex-1">
            <slot :hasError="hasError"></slot>
            <div class="text-red text-sm" v-if="hasError">
                {{ $t(errorMsgKey) }}
            </div>
        </div>
    </label>
</template>

<script>
export default {
    props: {
        name: { type: [String, Array], required: true },
        label: { type: String },
        labelWidthClass: { default: 'sm:w-32' },
        errors: { default: {} },
        required: { type: Boolean, default: false }
    },
    computed: {
        keys() {
            return Array.isArray(this.name) ? this.name : [this.name];
        },
        hasError() {
            return this.keys.some(k => !!this.errors[k]);
        },
        errorMsgKey() {
            const key = this.keys.find(k => this.errors[k]);
            return key ? this.errors[key] : '';
        },
        requiredClass() {
            return this.required ? 'required' : '';
        }
    }
};
</script>
